import InputBox from "../../../../../../packages/design-system/src/InputBox";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import * as React from 'react';
export default {
  InputBox,
  Spacings,
  React
};